const SpacesListing = () =>
  import("../../components/platform/SpacesListing.vue");

const routes = [
  // URL in RAFT where Vue JS component needs to match the following.
  // Path is used in B4, Alias in B3 if they are different paths.
  {
    path: "/raft/locative/space",
    alias: "/raft/manage_researchers/locations/spaces",
    name: "spaces_listing",
    component: SpacesListing,
  },
  {
    path: "/node/:contextNid([0-9]+)/spaces",
    alias: "/node/:contextNid([0-9]+)/view/spaces",
    name: "spaces_listing_node",
    component: SpacesListing,
    props: (route) => ({ contextNid: route.params.contextNid }),
  },
];

const globalComponents = {
  SpacesListing,
};

export {
  routes as spacesListingRoutes,
  globalComponents as spacesListingGlobalComponents,
};
